export const clearLocalStorage = () => {
  localStorage.removeItem("accessToken")
  localStorage.removeItem("tgUserId")
  localStorage.removeItem("tokenReceiveTime")
  localStorage.removeItem("userId")
  localStorage.removeItem("last-update-read")
}
